import { ActionKey } from 'modules/inventory/api/type'
import { useTranslation } from 'react-i18next'

import { alpha, Chip, useTheme } from '@mui/material'

type Props = {
  action: ActionKey
  label?: string
  size?: 'small' | 'medium'
}

export default function ActionPill({ action, label, size = 'small' }: Props) {
  const { t } = useTranslation('stock')
  const theme = useTheme()

  const LABEL_KEYS: Record<ActionKey, string> = {
    use_product: 'stock.history.tab.use_product',
    transfer_warehouse: 'stock.history.tab.transfer_warehouse',
    add_stock: 'stock.history.tab.add_stock',
    product_issue: 'stock.history.tab.product_issue',
    adjust_quantity: 'stock.history.tab.adjust_quantity',
    edit_stock: 'stock.history.tab.edit_stock',
    delete_stock: 'stock.history.tab.delete_stock',
  }

  const STYLE_BY_ACTION: Record<ActionKey, any> = {
    use_product: {
      color: theme.palette.warning.main,
      backgroundColor: alpha(theme.palette.warning.main, 0.08),
      border: '1px solid ' + theme.palette.warning.main,
    },
    transfer_warehouse: {
      color: theme.palette.info.main,
      backgroundColor: alpha(theme.palette.info.lighter, 0.08),
      border: '1px solid ' + theme.palette.info.light,
    },
    add_stock: {
      color: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.08),
      border: '1px solid ' + theme.palette.primary.main,
    },
    product_issue: {
      color: theme.palette.info.main,
      backgroundColor: alpha(theme.palette.info.lighter, 0.08),
      border: '1px solid ' + theme.palette.info.light,
    },
    adjust_quantity: {
      color: theme.palette.purple.main,
      backgroundColor: alpha(theme.palette.purple.main, 0.08),
      border: '1px solid ' + theme.palette.purple.main,
    },
    edit_stock: {
      color: theme.palette.common.black,
      backgroundColor: alpha(theme.palette.grey[200], 0.08),
      border: '1px solid ' + theme.palette.grey[400],
    },
    delete_stock: {
      color: theme.palette.error.main,
      backgroundColor: alpha(theme.palette.error.main, 0.08),
      border: '1px solid ' + theme.palette.error.main,
    },
  }

  const s = STYLE_BY_ACTION[action]
  const text = label ?? (action ? t(LABEL_KEYS[action]) : '')

  if (!text) return null
  return <Chip label={text} size={size} sx={{ borderRadius: 1, ...s }} />
}
